import { useState } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import ReorderIcon from '@mui/icons-material/Reorder';
import CloseIcon from '@mui/icons-material/Close';
import BabysitterSmSidebar from '../../modules/Babysitter/BabysitterSidebar/SmSidebar';
import ConsumerSmSidebar from '../ConsumerSidebar/ConsumerSmSidebar';
import { getRole } from '../../utils/auth-token-utils/cookie';

export default function TemporaryDrawer() {
  const [open, setOpen] = useState(false);
  const role = getRole();

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box
      sx={{ width: 250, color: 'white', bgcolor: 'black', height: '100vh' }}
      role="presentation"
    >
      {/* Close Button */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
        <Button onClick={toggleDrawer(false)}>
          <CloseIcon sx={{ color: 'white' }} /> {/* Set Close Icon to white */}
        </Button>
      </Box>
      {/*<Divider sx={{ borderColor: "gray" }} />*/}
      {role === 'Participant' ? <ConsumerSmSidebar /> : <BabysitterSmSidebar />}
    </Box>
  );

  return (
    <div>
      <Button onClick={toggleDrawer(true)}>
        <ReorderIcon sx={{ color: 'white' }} />{' '}
        {/* Set Reorder Icon to white */}
      </Button>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
}
